import * as React from 'react';

import * as styles from './MoreFiltersModalContentLayout.css';

export const MoreFiltersModalContentLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
